import { useChatStore } from "../../stores";
import { ChatBackend, ChatMessageId, ChatStatus, Room } from "../../types";
import Api from "../api";
import { createFormData, getFileHeaders } from "../utils";

class ChatApi extends Api {
  static getRooms(): Promise<Room[]> {
    return this.getData("/chat");
  }

  static getRoomChats(
    roomId: string,
    page: number = 1,
    newMsgs: number = 0
  ): Promise<ChatBackend> {
    return this.getData(
      `/chat/messages/${roomId}?page=${page}&new_msg=${newMsgs}`
    );
  }

  static sendChat(
    roomId: string,
    content: string,
    files: FileList,
    id: number
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      let fd = createFormData({
        content,
        "files[]": files,
        id,
      });

      const headers = getFileHeaders(files);

      this.postData<
        { event: "MessageSent" | "MessageFailed"; data: ChatMessageId },
        FormData
      >(`/message/new/${roomId}`, fd, { headers })
        .then((res) => {
          useChatStore
            .getState()
            .updateChatStatus(
              res.data,
              res.event === "MessageFailed"
                ? ChatStatus.Failed
                : ChatStatus.Sent
            );
          resolve();
        })
        .catch((err) => reject(err));
    });
  }
}

export default ChatApi;
